import React from 'react';
import { PRODUCT_NAME } from './constants';
export function Footer() {
  return <footer className="bg-graphite px-4 py-5 text-center text-xs text-white/65" data-id="element-72" data-mp="3gezcj1s77n03">
      <div className="mx-auto max-w-3xl space-y-2" data-id="element-73" data-mp="3gh3rqfvjs8fo">
        <p className="mx-auto max-w-2xl leading-relaxed" data-id="element-74" data-mp="32ovz90bar3ms">
          © 2026 {PRODUCT_NAME} — All Rights Reserved. The information provided
          on this website is intended for educational purposes only and is
          designed as a professional coaching resource for Strength &amp;
          Conditioning Coaches. It is not intended to replace professional
          judgment, sport-specific programming decisions, or the standards
          established by your organization, club, university, or governing body.
          Always apply your professional expertise and prioritize athlete safety
          when designing and delivering training programs.
        </p>
        <nav aria-label="Legal links" className="flex justify-center gap-3 font-display text-[10px] font-bold uppercase tracking-wide text-white/80" data-id="element-75" data-mp="2ey05vyr700df">
          <a href="#terms" className="hover:text-sport focus:outline-none focus:ring-2 focus:ring-sport" data-id="element-76" data-mp="3gagyrmubl72o">
            Terms &amp; Conditions
          </a>
          <span data-id="element-77" data-mp="3v5desm8deyqb">•</span>
          <a href="#privacy" className="hover:text-sport focus:outline-none focus:ring-2 focus:ring-sport" data-id="element-78" data-mp="3q8wq9qx9eicp">
            Privacy Policy
          </a>
          <span data-id="element-79" data-mp="33xdnwzdzwrz">•</span>
          <a href="#contact" className="hover:text-sport focus:outline-none focus:ring-2 focus:ring-sport" data-id="element-80" data-mp="34gx5i4oqt84">
            Contact
          </a>
        </nav>
      </div>
    </footer>;
}